import { DatePicker } from "antd";
import dayjs from "dayjs";
import {  apmTimeRange } from "utils/constants";

const { RangePicker } = DatePicker;

export const DateRangeApmSelector = ({ onChange,defaultValue }) => {
  const presets = apmTimeRange.statsPeriod.options.map((opt) => ({
    label: opt.label,
    value: opt.value.includes("h")
      ? [dayjs().subtract(parseInt(opt.value), "hour"), dayjs()]
      : [dayjs().subtract(parseInt(opt.value), "day"), dayjs()],
    key: opt.value, 
  }));

  const matchedPreset = presets?.find((p) => p.key === defaultValue);
  const defaultRange = matchedPreset?.value; // default date


  return (
    <RangePicker
      presets={presets}
      style={{ width: 260 }}
      defaultValue={defaultRange}
      onChange={(dates, dateStr) => {
        const matched = presets.find(
          (p) =>
            p.value[0].isSame(dates?.[0], "minute") &&
            p.value[1].isSame(dates?.[1], "minute")
        );
        onChange?.(
          matched ? matched.key : { start: dateStr[0], end: dateStr[1] }
        );
      }}
    />
  );
};
